export default __webpack_public_path__ + "locales/az/FormGallery.json?hash=e54e7d483a609c0cdd8989c997fed3b4";